import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getFeedbackIcon, getFeedbackMessageColors } from '../../utils';
import { IconModule } from '@iota/iota-ui-components';
import { FeedbackBannerVariant } from '../feedback-banner/feedback-banner.component';

@Component({
    selector: 'app-feedback-toast',
    standalone: true,
    imports: [CommonModule, IconModule],
    templateUrl: './feedback-toast.component.html'
})
export class FeedbackToastComponent {
    @Input() variant: FeedbackBannerVariant = 'confirmation';
    @Input() header?: string;
    @Input() message = '';
    @Input() date?: string;
    @Output() closeMessage = new EventEmitter<void>();

    onCloseMessageClick() {
        this.closeMessage.emit();
    }

    protected readonly getFeedbackMessageColors = getFeedbackMessageColors;
    protected readonly getFeedbackIcon = getFeedbackIcon;
}
